import REPORT from '@/constants/report';

// 공통으로 쓰는 자바스크립트 함수 모음
export default {
  methods: {
    isShowMenu(isShow) {
      this.$store.dispatch('toggleMenu', isShow).then();
    },
    goPage(path) {
      this.$router.push(path);
    },
    goAccLogin() {
      this.$router.push('/acc/login');
    },
    goPrevious() {
      this.$router.go(-1);
    },
    getLanguage() {
      let language = localStorage.language;
      if (!language) {
        if (window.navigator.languages) {
          language = window.navigator.languages[0];
        } else {
          language = window.navigator.language || 'en';
        }
        if (language === 'kr' || language === 'ko' || language === 'ko-KR') {
          localStorage.language = 'kr';
        } else {
          localStorage.language = 'en';
        }
      }
      return localStorage.language;
    },
    getMyRoleItem(point) {
      let result;

      if (point > 90) {
        result = REPORT.ROLEITEM.STRONGLY_AGREE;
      } else if (point > 75) {
        result = REPORT.ROLEITEM.AGREE;
      } else if (point > 60) {
        result = REPORT.ROLEITEM.USUALLY;
      } else if (point > 50) {
        result = REPORT.ROLEITEM.DISAGREE;
      } else {
        result = REPORT.ROLEITEM.STRONGLY_DISAGREE;
      }

      return result;
    },
    getRoleItem(point) {
      let result;

      if (point > 80) {
        result = REPORT.ROLEITEM.STRONGLY_AGREE;
      } else if (point > 60) {
        result = REPORT.ROLEITEM.AGREE;
      } else if (point > 40) {
        result = REPORT.ROLEITEM.USUALLY;
      } else if (point > 20) {
        result = REPORT.ROLEITEM.DISAGREE;
      } else {
        result = REPORT.ROLEITEM.STRONGLY_DISAGREE;
      }

      return result;
    },
    showMenu() {
      this.isShowMenu(true);
    },
    setLang(lang) {
      this.$store.dispatch('setI18n', lang).then();
    },
    validEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPassword(password) {
      if (password) {
        return password.length >= 8;
      }
      return password;
    },
    validNickname(nickname) {
      if (nickname) {
        return nickname.length > 1;
      }
      return nickname;
    },
    validName(name) {
      if (name) {
        return name.length > 1;
      }
      return name;
    },
    validBirth(num) {
      // eslint-disable-next-line eqeqeq
      const filter = this.years().filter(data => data == num);
      return filter.length > 0;
    },
    validSex(sex) {
      // eslint-disable-next-line eqeqeq
      const filter = this.sexes().filter(data => data.value == sex);
      return filter.length > 0;
    },
    validEdu(education) {
      // eslint-disable-next-line eqeqeq
      const filter = this.educations().filter(data => data.value == education);
      return filter.length > 0;
    },
    chkEmojiContains(text) {
      const emoji = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
      return emoji.test(text);
    },
    removeEmojiText(text) {
      return text.replace(
        /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g,
        '',
      );
    },
    setClassName(selector, value) {
      document.querySelector(selector).className = value;
    },
    getClassName(selector) {
      return document.querySelector(selector).className;
    },
    years() {
      const yearData = [];
      for (let i = 1920; i < 2010; i += 1) {
        yearData.push(i);
      }
      return yearData;
    },
    sexes() {
      const sexData = [
        { title: this.$i18n.t('acc.signUp.sex.man'), value: 1 },
        { title: this.$i18n.t('acc.signUp.sex.woman'), value: 2 },
      ];
      return sexData;
    },
    educations() {
      const educationData = [
        { title: this.$i18n.t('common.education.middle'), value: 1 },
        { title: this.$i18n.t('common.education.high'), value: 2 },
        { title: this.$i18n.t('common.education.attending'), value: 6 },
        { title: this.$i18n.t('common.education.university'), value: 4 },
        { title: this.$i18n.t('common.education.graduate'), value: 5 },
      ];
      return educationData;
    },
    textCopy(text) {
      const dom = document.getElementById('app');
      const temp = document.createElement('input');
      temp.classList.add('on'); // 안보이도록 처리

      // 복사할 대상
      temp.value = text;

      dom.appendChild(temp); // 삽입

      const userAgent = window.navigator.userAgent;
      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        const range = document.createRange();
        range.selectNodeContents(temp);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        temp.setSelectionRange(0, 999999);
      } else {
        temp.select(); // 선택
      }
      document.execCommand('copy'); // 복사
      temp.remove();
    },
    invalidateLogin() {
      this.$store.dispatch('logOut').then(() => {
        localStorage.removeItem('shareUserSeqId');
        localStorage.removeItem('addUserSeqId');

        this.goAccLogin();
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/common.js